import React from 'react';
import Button from 'epn-ui/umd/dist/components/Button';

import BaseGrid from '@base/BaseGrid';
import Stepper from '@pages/faq/self-employed/Stepper';

import useI18n, { getLocalePaths } from '@i18n';
import externalLinks from '@config/external-links.json';
import {
    getNalogRegistrationSteps,
    getEpnRegistrationSteps,
} from '@pages/faq/self-employed/config';

// HOCs
import WithRole, { rolesEnum } from '@HOCs/WithRole';
import { companyName } from '../../../../config/globalDomain';

const SelfEmployedPage = () => {
    const { t } = useI18n();

    const nalogRegistrationStepsConfig = getNalogRegistrationSteps(t);
    const withEpnRegistration = getEpnRegistrationSteps(t);

    return (
        <BaseGrid item initial={12} className="flex-wrap pb-20">
            <h1 className="mb-6 font-medium text-blueGray-600 text-h2 md:text-h1">
                {t('Instruction for self-employed person')}
            </h1>
            <p className="mb-6 text-blueGray-500 text-p1 md:mb-8">
                {t('How to register as a self-employed person in the Federal Tax Service')}
                <br /> <br />
                {t('My taxes is an official application')}
            </p>
            <div className="flex flex-col mb-6 xs:flex-row sm:mb-8">
                <Button
                    type="ghost"
                    responsive="xs"
                    className="mb-4 xs:mb-0 xs:mr-6"
                    to={externalLinks.selfEmployedLaw}
                >
                    {t('Low on self-employed persons')}
                </Button>
                <Button type="primary" responsive="xs" to={externalLinks.nalogApp}>
                    {t('Mobile application “My taxes”')}
                </Button>
            </div>
            <div className="mb-8">
                <h2 className="mb-4 font-medium text-blueGray-600 text-sub xs:mb-6 md:mb-8 md:text-h2">
                    {t(
                        'How to register in the application “My taxes” through the taxpayer’s personal account',
                    )}
                </h2>
                <p className="mb-6 text-blueGray-500 text-p1 md:mb-8">
                    {t('It’s the simplest way to register through any device')}
                </p>
                <Stepper {...nalogRegistrationStepsConfig} />
            </div>
            <div className="mb-8">
                <h2 className="mb-4 font-medium text-blueGray-600 text-sub xs:mb-6 md:mb-8 md:text-h2">
                    {t('How to register earnings from ePN', { companyName })}
                </h2>
                <Stepper {...withEpnRegistration} />
            </div>
            <p className="mb-20 font-medium text-center text-blueGray-600 text-p1 sm:text-sub">
                {t('You have registered your income and can pay tax on it')}
            </p>
        </BaseGrid>
    );
};

export const getStaticProps = async ({ params }) => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths = async () => {
    return { paths: getLocalePaths(), fallback: false };
};

export default WithRole(SelfEmployedPage, [rolesEnum.guest]);
